import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';

import { connect } from 'react-redux';

import * as CalendarActions from './actions';
import CalendarMonth from './calendar-month';

import CalendarFiltersReset from './filters/calendar-filters-reset';
import CalendarFilters from './filters/calendar-filters';


import { create } from '@adage/calendar';

import { IMainstreetEvent, ICalendarState } from './classes';

interface ICalendarContainerState {
    // Give this a type once real data is passed down.
    eventsData: any;
    mobileGridClass: string;
    hiddenClass: string;
    inverseHiddenClass: string;
}

class CalendarContainer extends React.Component<ICalendarState<IMainstreetEvent>, ICalendarContainerState>{

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            eventsData: null,
            mobileGridClass: '',
            hiddenClass: 'calendar-filters-closed',
            inverseHiddenClass: 'calendar-filters-open',
        };
        this.mobileGridToggle = this.mobileGridToggle.bind(this);

    }
    mobileGridToggle() {
        if (this.state.mobileGridClass === '')
            this.setState({ mobileGridClass: ' mobile-grid-open' });
        else
            this.setState({ mobileGridClass: '' });
    }
    addClassName() {
        if (this.state.hiddenClass === 'calendar-filters-closed') {
            this.setState({ hiddenClass: 'calendar-filters-open' });
            this.setState({ inverseHiddenClass: 'calendar-filters-closed' });
        }
        else {
            this.setState({ hiddenClass: 'calendar-filters-closed' });
            this.setState({ inverseHiddenClass: 'calendar-filters-open' });
        }
    }
    render() {
      const startMonth = this.props.startDate.format( 'MM-YYYY' ),
        endMonth = this.props.endDate.format( 'MM-YYYY' );

        return (
            <main className={'calendar' + this.state.mobileGridClass}>
                {
                    <div className="calendar-container">
                        <div className="calendar-body">
                            <div className="calendar-filters-container">
                                <div className="calendar-filters-title">
                                    <div className="calendar-filters-title-inner">
                                        <a className={this.state.inverseHiddenClass} onClick={this.addClassName.bind(this)}>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-refiner" />
                                            </svg>
                                            <span className="text">
                                                <span className="visually-hidden">Filter icon</span>
                                            </span>
                                        </a>
                                        <a className={this.state.hiddenClass} onClick={this.addClassName.bind(this)}>
                                            <svg className="svg-icon calendar-icon-close" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close" />
                                            </svg>
                                            <span className="text">
                                                <span className="visually-hidden">Close filters dropdown</span>
                                            </span>
                                        </a>
                                        <a className="calendar-filters-link" onClick={this.addClassName.bind(this)}><h3>Filters</h3></a>
                                    </div>
                                    <CalendarFiltersReset classModifier="calendar-mobile" />
                                </div>
                                <div className={this.state.hiddenClass}>
                                    <CalendarFilters selectedEventTypeFilter={this.props.eventTypeFilter}
                                        selectedCourseTypeFilter={this.props.courseTypeFilter}

                                        selectedMonthFilter={this.props.showAllMonths || this.props.startDate.format( 'MM-YYYY' ) != this.props.endDate.format( 'MM-YYYY' ) ? "" : this.props.startDate.format('YYYY-MM-DD')}

                                        selectedInstructorFilter={this.props.instructorFilter}
                                        selectedPriceFilter={this.props.showOnlyFreeEvent}
                                        selectedFormatFilter={this.props.formatFilter}
                                        selectedLocationFilter={this.props.locationFilter} />
                                </div>
                            </div>
                            <CalendarMonth baseModel={this.props} />
                        </div>
                    </div>
                }
            </main>
        );
    }
    componentDidMount() {
        //Hide the loader
        document.getElementById('calendarLoader').classList.add('calendar-hide');
    }
}

export default connect((state) => state)(CalendarContainer);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar-container.tsx